<template>
  <div class="home-container">
    <div class="home-content" v-if="doorType">
      <!-- 搜索 -->
      <div>
        <el-form :model="searchForm" ref="searchForm" label-width="80px">
          <el-row>
            <el-col :span="8">
              <el-button
                size="small"
                @click="serveType"
                type="primary"
                style="width: 90px;margin:15px"
                >服务类型</el-button
              >
            </el-col>            
          </el-row>
        </el-form>
      </div>         
      <el-table
        border
        :data="tableData"
        v-loading="isShowloading"
        style="width: 100%"
      >
        <el-table-column prop="userName" label="用户名称" align="center">
        </el-table-column>
        <el-table-column prop="houseNumber" label="用户地址" align="center">
        </el-table-column>   
        <el-table-column prop="reachDoorServeCategory" label="服务名称" align="center">
        </el-table-column>         
        <el-table-column prop="subscribeTime" label="预约上门时间" align="center">
        </el-table-column>    
        <el-table-column prop="status" label="处理状态" align="center" :formatter="statusList">
        </el-table-column>                       
        <el-table-column prop="des" label="描述" align="center">
        </el-table-column>   
        <el-table-column prop="handleDes" label="处理描述" align="center">
        </el-table-column>          
        <el-table-column fixed="right" align="center" label="操作">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status == 0"
              type="text"
              size="small"
              @click="updataCharacter(scope.row)"
              >处理</el-button
            >
          </template>    
        </el-table-column>

      </el-table>
      <!-- 分页器 -->
      <div class="block" style="margin-top: 15px">
        <el-pagination
          align="center"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30,50,100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
      <!-- 新增模态框 -->
      <el-dialog title="审核" :visible.sync="isAddModal" width="40%">
        <el-form
          ref="form"
          :model="addData"
          label-width="90px"
          :rules="addDataRules"
          label-position="center"
        >  
           <el-row>
            <!-- <el-col :span="24">
              <el-form-item label="选择类型" prop="status">
                <el-select clearable filterable v-model="addData.status" placeholder="请选择">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
              </el-form-item>
            </el-col>     -->
            <el-col :span="24">
              <el-form-item label="描述" prop="handleDes">
                <el-input
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                placeholder="请输入描述"
                v-model="addData.handleDes">
                </el-input>
              </el-form-item>
            </el-col>                   
          </el-row>         
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="isAddModal = false">取 消</el-button>
          <el-button type="primary" @click="submit" 
            >确 定</el-button
          >
        </span>
      </el-dialog>        
    </div>
    <div v-else>
      <doorClass :doorId="doorId" @back="back"></doorClass>
    </div>
  </div>
</template>

<script>
import doorClass from './components/doorClass.vue'
export default {
  components:{
    doorClass
  },
  data() {
    return {
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10, // 每页的数据条数
      tableData: [],
      isShowloading:false,
      isAddModal:false,
      doorType:true,
      options:[{
        label:'已处理',
        value:1
      },{
        label:'取消',
        value:0
      }],      
      addData:{
        id:"",
        status:"",
        handleDes:""
      },
      addDataRules: {
        // status: [{ required: true, message: "请选择处理状态", trigger: "blur" }],
        handleDes: [{ required: true, message: "请输入处理描述", trigger: "blur" }]
      },       
      searchForm: {
        userName: "",
      },
      doorId:1
    };
  },
  mounted() {
    this.onLoad();
  },
  methods: {
    statusList(row){
      return row.status == 0 ? '未处理' : '已处理'
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          var data = {
            id: this.addData.id || "",
            handleDes: this.addData.handleDes,
            status: 1,
          };
          this.$Apis.reachDoorServeHandle(data).then((res) => {
            this.isAddModal = false;
            if (res.code == 200) {
              this.onLoad();
              this.$message.success("操作成功");
            } else {
              this.$message.warning(res.msg);
            }
          });
        }
      });
    },     
    // 审核
    updataCharacter(row){
        this.addData.id = row.id;
        this.isAddModal = true
    },      
    // 类型设置
    serveType(){
      this.doorType = false
    },
    back(){
      this.doorType = true
      this.onLoad()
    },
    // 重置按钮
    restSearch() {
      for (let item in this.searchForm) {
        this.searchForm[item] = "";
      }
      this.onLoad();
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.onLoad();
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.onLoad();
    },    
    onLoad() {
      var data = {
        current: this.currentPage,
        size: this.pageSize,
      }
      this.$Apis.reachDoorServeList(data).then(res=>{
        if (res.code == 200) {
          let { current, list, pages, total } = res.data;
          this.currentPage = current;
          this.size = pages;
          this.total = total;
          this.tableData = list;
        } else {
          this.$message.warning(res.msg);
        }
      })
    },
  },
};
</script>

<style>
</style>